import { AppProvider, useApp } from "./context/AppContext";
import { LockGate } from "./components/auth/LockGate";
import { AppShell } from "./components/shell/AppShell";
import "./theme/base.css";
import "./theme/theme.css";

function Root() {
  const { isUnlocked } = useApp();
  return isUnlocked ? <AppShell /> : <LockGate />;
}

export default function App() {
  return (
    <AppProvider>
      <Root />
    </AppProvider>
  );
}
